module.exports = __webpack_public_path__ + "static/media/loginView.157c5ddb.yaml";